export const getBoundsFromPoints = (points: { lat: number; lng: number }[]) => {
  return points.reduce(
    (bounds, point) => {
      if (bounds.north === 0 || point.lat > bounds.north) {
        bounds.north = point.lat;
      }
      if (bounds.south === 0 || point.lat < bounds.south) {
        bounds.south = point.lat;
      }
      if (bounds.east === 0 || point.lng > bounds.east) {
        bounds.east = point.lng;
      }
      if (bounds.west === 0 || point.lng < bounds.west) {
        bounds.west = point.lng;
      }
      return bounds;
    },
    {
      north: 0,
      south: 0,
      east: 0,
      west: 0
    } as {
      north: number;
      south: number;
      east: number;
      west: number;
    }
  );
};
